export default __webpack_public_path__ + "resources/icons/n210-e598.png";